<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>门店</el-breadcrumb-item>
      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search flex-r-x" style="width:100%">
      <el-form-item>
        <el-button v-if="IsHeadOffice==1" size="mini" type="primary" @click="add"
          >+ 添加门店</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button size="mini" v-if="IsHeadOffice==1"  type="primary" @click="setContinue"
          >续费</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="loading"
      size="small"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="StoresName" label="门店名称"> </el-table-column>
       <el-table-column prop="Name" label="联系人"> </el-table-column>
      <el-table-column prop="StoresPhone" label="联系电话"> </el-table-column>
      <el-table-column prop="DueToTime" label="到期时间"> </el-table-column>
      <el-table-column prop="time" label="营业时间"> 
           <template slot-scope="scope">
          <div>{{scope.row.KstartTime}} ~ {{scope.row.KendTime}}</div>
        </template>
      </el-table-column>

      <!-- <el-table-column sortable prop="sfz" label="sfz" >
      </el-table-column> -->

      <el-table-column prop="Isdisable" label="状态">
        <template slot-scope="scope">
            <span class="Danger"  v-if="scope.row.Isdisable == 1">
              禁用
            </span>
            <span class="Success" v-if="scope.row.Isdisable == 0">
              正常
            </span>
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="warning" v-if=" scope.row.Sid ==  0 && IsHeadOffice==1" plain disabled  size="mini" @click="handleEdit(scope.row)"
            >禁用</el-button
          >
          <el-button v-if="scope.row.Isdisable == 0 && scope.row.Sid> 0 && IsHeadOffice==1" type="warning" plain size="mini" @click="handlejin(scope.row)">禁用</el-button>
           <el-button v-if="scope.row.Isdisable == 1 && scope.row.Sid >0 && IsHeadOffice==1"  type="info" plain size="mini" @click="handlejie(scope.row)">解禁</el-button>
          
   
          <!-- <el-button
            size="mini"
            type="danger"
            @click="del(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false
      :title="title"
      :visible.sync="editFormVisible"
      :direction="direction"
    
      size="40%"
    >
    
    <el-tabs v-model="activeName"   style="padding-left:10px;postion:fixed" >
      <el-tab-pane label="门店信息" name="first" >     
      </el-tab-pane>
    <el-tab-pane label="门店简介" name="second">       
    </el-tab-pane>
      <!-- :before-close="handleClose" -->

        </el-tabs>
        <div class="demo-drawer__content"  v-show="activeName == 'first'">
        <el-form
          label-width="90px"
          :model="editForm"
          :rules="rules"
          ref="editForm"
        >
          <el-form-item label="门店名称:" prop="StoresName">
            <el-input
              size="small"
              v-model="editForm.StoresName"
              auto-complete="off"
              placeholder="请输入门店名称"
              style="width: 215px"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系人:" prop="Name">
            <el-input
              size="small"
              v-model="editForm.Name"
              auto-complete="off"
              placeholder="请输入联系人"
              style="width: 215px"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="Phone">
            <el-input
              size="small"
              v-model="editForm.Phone"
              auto-complete="off"
              placeholder="请输入门店电话"
              style="width: 215px"
            ></el-input>
          </el-form-item>
          <el-form-item label="门店电话:" prop="StoresPhone">
            <el-input
              size="small"
              v-model="editForm.StoresPhone"
              auto-complete="off"
              placeholder="请输入门店电话"
              style="width: 215px"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="营业时间:" prop="time">
  
                <el-time-select
                style="width:130px"
                size="small"
                  v-model="editForm.KstartTime"
                  :picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:55'
                  }"
                placeholder="开始时间">
                  </el-time-select>
                  <span>~</span>
                     <el-time-select
                       style="width:130px"
                  v-model="editForm.KendTime"
                    size="small"
                  :picker-options="{
                    start: '00:00',
                    step: '00:15',
                    end: '23:55'
                  }"
                placeholder="结束时间">
                  </el-time-select>
          </el-form-item>
          <el-form-item label="省份:" prop="Province">
            <el-select  size="small" v-model="editForm.Province" @change="tocity()" placeholder="请选择">
              <el-option
                v-for="item in provinceList"
                :key="item.ProvinceID"
                :label="item.ProvinceName"
                :value="item.ProvinceID">
              </el-option>
            </el-select>
            <!-- <el-cascader
              size="small"
              v-model="value"
      
            ></el-cascader> -->
                    <!-- :options="options"
              @change="handleChange" -->
          
          </el-form-item>
          <el-form-item label="城市:" prop="City">
            <el-select  size="small" v-model="editForm.City" placeholder="请选择"  @change="toArea()">
              <el-option
                v-for="item in cityList"
                :key="item.CityID"
                :label="item.CityName"
                :value="item.CityID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域:" prop="Area">
            <el-select  size="small" v-model="editForm.Area" placeholder="请选择">
              <el-option
                v-for="item in  DistrictList"
                :key="item.DistrictID"
                :label="item.DistrictName"
                :value="item.DistrictID">
              </el-option>
            </el-select>
            <!-- <el-cascader
              size="small"
              v-model="value"
      
            ></el-cascader> -->
                    <!-- :options="options"
              @change="handleChange" -->
          
          </el-form-item>
        
          <el-form-item label="详细地址:" prop="Address">
            <el-input
              size="small"
              v-model="editForm.Address"
              auto-complete="off"
              placeholder="请输入详细地址"
              style="width: 215px"
            ></el-input>
          </el-form-item>
          <el-form-item label="精确坐标:" prop="DWAddress">
            <div class="map">
                <el-input v-model="editForm.DWAddress"    size="small"  style="width:70%; " placeholder="请输入地址来直接查找相关位置"></el-input>
                 <el-button size="mini" type="primary" @click="searchMap()">搜索</el-button>
                <baidu-map
                  class="bmView"
                  :scroll-wheel-zoom="true"
                  :center="location"
                  :zoom="zoom"
                  @click="getLocationPoint"
                  ak="XC4D0Hgvsp243FB55rnRMBVuBX6TWZxi"
                >
                  <bm-view style="width:70%; height:300px; flex: 1"></bm-view>
                  <bm-local-search :keyword="map" :auto-viewport="true" :location="location" :autoViewport="true" :pageCapacity="5"  @infohtmlset="choo"></bm-local-search>
                   <!-- <bm-polygon :path="polygonPath"></bm-polygon> -->
                </baidu-map>
            </div>
            <div id="r-result"></div>
          </el-form-item>
          <el-form-item label="门店logo:" prop="HeadUrllogo">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrllogo !== ''">
                    <img
                      :src="editForm.HeadUrllogo"
                      style="height: 100px;width:100px"
                      alt="图片"
                      @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                  
                    @click="uploadPicture('HeadUrl')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                    <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加logo"
                />
          </el-form-item>
          <el-form-item label="门店封面图:" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="width: 121px; height: 81px"
                      alt="图片"
                        @click="uploadPicture('HeadUrllogo')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                   style="width: 121px; height: 81px"
                    @click="uploadPicture('HeadUrllogo')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                    <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加"
                />
          </el-form-item>

          <el-form-item label="客服二维码:" prop="KFQrCode">
                <div class="list-img-box cursor
" >
                  <div v-if="editForm.KFQrCode !== ''">
                    <img
                     @click="uploadPicture('KFQrCode')"
                      :src="editForm.KFQrCode"
                      style="width: 100px; height: 100px"
                      alt="图片"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('KFQrCode')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                 <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.KFQrCode"
                  placeholder="请添加二维码"
                />
          </el-form-item>
          <el-form-item label="首页轮播图:" prop="mainImage">
            <div class="flexc-cen-x">
                <div class="list-img-box cursor">
                  <div v-if="img1 !== ''">
                    <img
                      :src="img1"
                    style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img1')"
                    />
                      <div class="flex-xy">
                  <el-button  title="删除"  @click="delimglb(1)"  size="mini"  type="danger" icon="el-icon-delete" ></el-button>
                   </div>
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="width: 121px; height: 81px"
                    @click="uploadPicture('img1')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                   <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img2 !== ''">
                    <img
                      :src="img2"
                      style="width: 121px; height: 81px"
                      alt="图片"
                        @click="uploadPicture('img2')"
                    />
                    <div class="flex-xy">
                  <el-button  title="删除"  @click="delimglb(2)"  size="mini"  type="danger" icon="el-icon-delete" ></el-button>
                   </div>
                  </div>

                  <div
                    v-else 
                    class="upload-btn"
                   style="width: 121px; height: 81px"
                    @click="uploadPicture('img2')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                    <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img3 !== ''">
                    <img
                      :src="img3"
                  style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img3')"
                    />
                    <div class="flex-xy">
                  <el-button  title="删除"  @click="delimglb(3)"  size="mini"  type="danger" icon="el-icon-delete" ></el-button>
                   </div>
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                   style="width: 121px; height: 81px"
                    @click="uploadPicture('img3')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                 <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
            </div>
                <!-- <input
                  type="hidden"
                  v-model="formValidate.mainImage"
                  placeholder="请添加轮播图"
                /> -->
          </el-form-item>

  
    
            <!-- 剪裁组件弹窗 -->
            

          <!-- <el-form-item label="联系电话" prop="Phone">
            <el-input
              size="small"
              v-model="editForm.Phone"
              auto-complete="off"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item v-if="title == '添加'" label="余额" prop="money">
            <el-input
              size="small"
              v-model="editForm.money"
              auto-complete="off
              placeholder="请输入余额"
            ></el-input>
          </el-form-item> -->
        </el-form>

        </div>
        <Editor :key="timer" v-show="activeName == 'second'" v-bind:value="editForm.StoresInfo" v-model="editForm.StoresInfo"  style="margin-bottom:150px;margin-top:-10px">
        </Editor>
       <div class="demo-drawer__footer flex-r-x" style="width:40%" >
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            class="title"
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
            <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
            </el-dialog>
            <!--查看大封面-->
            <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
              <img
                :src="imgName"
                v-if="imgVisible"
                style="width: 100%"
                alt="查看"
              />
            </el-dialog>
    <el-dialog title="续期设置" :visible.sync="showRightDrawer" width="700px" @click="closeDialog1">
    <el-form :model="PayForm" ref="PayForm" label-width="130px" label-position="right">
                    <el-form-item label="续期时长：">
                        <div class="BuyBoxWrap">
                            <div class="BuyBox" :class="idx==index?'hover':''" v-for="(item,idx) in BuyList" :key="idx" @click="getChoosed(item,idx)">
                                <p><b>{{item.title}}</b></p>
                                <p>{{item.Contents}}</p>
                            </div>
                            <!-- {{PayForm}} -->
                        </div>
                    </el-form-item>
                    <el-form-item label="支付方式：">
                        <el-radio-group v-model="PayForm.Type">
                            <el-radio label="1"><i class="iconfont icon-wxPay"></i> 微信支付</el-radio>
                         </el-radio-group>
                    </el-form-item>
                    <el-form-item label="应付金额：">
                        {{PayForm.BuyAmount}}
                    </el-form-item>
                    <el-form-item>
                        <!-- @hide="changePopShow" -->
                        <el-popover
                            placement="top"
                            width="50"
                            trigger="click"
                            @hide="changePopShow"
                            v-if="showPopover || Qrcode!==''"
                            >
                            <div style="text-align:center;">
                                <el-image
                                style="width: 100px; height: 100px;margin:10px;"
                                :src="QrcodeImg" fit="cover"></el-image>
                                <p>请用微信扫码支付</p>
                            </div>
                            <el-button slot="reference" type="primary" size="medium" @click="submitToPay">确认购买</el-button>
                        </el-popover>
                         <el-button @click="closePayDrawer">取消</el-button>
                    </el-form-item>
                </el-form>  
    </el-dialog>

  </div>
</template>

<script>
// import { Upload} from "@/api/http.js"; 

import CropperImage from "../../components/CropperImage";
import  Editor from '../../components/editor'
import QRCode from 'qrcode'
import { getListStores, getBuyInfo, addShopBuyInfo,getListProvince,getListCity,getListDistrict } from "@/api/getData";
import Pagination from "../../components/Pagination";
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmView from 'vue-baidu-map/components/map/MapView.vue'
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'
export default {
  components: {
    Editor,
    CropperImage,
    Pagination,
   BaiduMap,
      BmView,
      BmLocalSearch
  },
  data() {
    return {
      location: {
        lng: 116.404,
        lat: 39.915
      },
      zoom: 12.8,
      addressKeyword: "",
      activeName:'first',
      provinceList:[],
      provinceName:'',
      cityName:'',
      AreaName:'',
      cityList:[],
      DistrictList:[],
      img1:'',
      img2:'',
      img3:'',
      title:'',
      SelectStoresID:this.$route.params.id,
      IsHeadOffice:localStorage.getItem("IsHeadOffice"),
      formValidate: {
        mainImage: "",
      },

      ruleValidate: {
        mainImage: [{ required: true, message: "请上传封面", trigger: "blur" }],
      },
      //裁切图片参数
      cropperModel: false,
      showRightDrawer: false,
      cropperName: "",
      imgName: "",
      imgVisible: false,

      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
 timer: '',
      value: "",
      direction: "ltr",
      date: [],
      value1: "",
      stime: "",
      etime: "",
      buyList: [],
      BuyList: [],
      PayForm:{
                    BuyID:"1",
                    Type:"1",
                    BuyAmount:"",
                },

      info: "",
      index:0,
      timer1:null,
      Qrcode:"",
      QrcodeImg:"",
      NotifyId:"",
      showPopover:true,
      tableData: [],
      map:'',
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      editForm: {
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        HeadUrl:'',
        KFQrCode:'',
        StoresName:'',
        Name:'',
        Phone:'',
        StoresPhone:'', 
        StoresInfo:'',
        KstartTime:'',
        KendTime:'',
        DWAddress:'',
        longitude:'',
      Address:'',
        // token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        StoresName: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
        ],
        Name: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        Phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
       StoresPhone: [
          { required: true, message: "请输入门店电话", trigger: "blur" },
        ],
        Address:[{required: true, message: "请输入详细地主", trigger: "blur"},],
        DWAddress:[{required: true, message: "请输入精确坐标", trigger: "blur"},],
        Province: [
          { required: true, message: "请选择省份", trigger: "blur" },
        ],
        City: [
          { required: true, message: "请选择城市", trigger: "blur" },
        ],
        Area: [
          { required: true, message: "请选择区域", trigger: "blur" },
        ],
        // deptNo: [
        //   { required: true, message: "请输入登录账号", trigger: "blur" },
        // ],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  // 注册组件

  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.getList()
    this.getListProvince()

    // this.getdata(this.formInline)
    // this.getList()
  },destroyed(){
            clearInterval(this.timer1)
            this.timer1 = null
            // console.log(this.timer,1)
 },
 beforeDestroy(){
            clearInterval(this.timer1);
            this.timer1 = null
          },
    
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    tosetting(){
        this.$router.go(-1)
      },
    searchMap(){
      this.provinceList.forEach(items => {
         if(items.ProvinceID== this.editForm.Province){
              this.provinceName= items.ProvinceName
          }
      });
      this.cityList.forEach(items => {
         if(items.CityID == this.editForm.City){
              this.cityName= items.CityName
          }
      });
      this.DistrictList.forEach(items => {
          if(items.DistrictID == this.editForm.Area){
              this.AreaName = items.DistrictName
          }
      });
      this.map = this.provinceName + this.cityName + this.AreaName + this.editForm.DWAddress
    },
choo(e){
  console.log(e.point.lng)
  this.editForm.DWAddress = e.address
  this.editForm.longitude = e.point.lng;
  this.editForm.latitude =e.point.lat

},
     getLocationPoint(e) {
      // this.lng = e.point.lng;
      // this.lat = e.point.lat;
      console.log(e.point)
       let geoc= new BMap.Geocoder();
        var that = this
      /* 创建地址解析器的实例 */
    //  var geoc = new BMapGL.Geocoder();
        geoc.getLocation(e.point, function(rs){
          var addComp = rs.addressComponents;
          that.editForm.DWAddress =   addComp.province + ", " + addComp.city + ", " + addComp.district + ", " + addComp.street + ", " + addComp.streetNumber
      })
      this.longitude
      this.editForm.longitude = e.point.lng;
      this.editForm.latitude =e.point.lat

      /* 获取位置对应的坐标 */
      // geoCoder.getPoint(this.addressKeyword, point => {
      //   this.selectedLng = point.lng;
      //   this.selectedLat = point.lat;
      // });
      // /* 利用坐标获取地址的详细信息 */

      geoc.getLocation(e.point, res=>{
          console.log(res);
      })
     },
handlejin(row){
 this.$confirm("确定要禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
          SelectStoresID:this.$route.params.id,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ID:row.ID,
          Isdisable:1
        }
        var that = this
        this.ajax('editStoresisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "禁用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
          
        });
   
},
handlejie(row){
 this.$confirm("确定要启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.$route.params.id,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ID:row.ID,
          Isdisable:0
        }
        var that = this
        this.ajax('editStoresisable.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "启用成功",duration:2000,
              });
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
         
        });
   
},
getListProvince(){
          var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token")
      }
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
       this.ajax('getListProvince.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.provinceList = res.data
            }
            loading.close();
        })

},
    toArea(){
      this.editForm.Area = ''
      this.DistrictList=''
      this.getListDistrict()
    },
    tocity(){
    this.editForm.City = ''
    this.cityList=''
    this.editForm.Area = ''
    this.DistrictList=''
    this.getListCity()
      // getListDistrict
    },

  async getListDistrict(){
    const crs = await getListDistrict({
          token: localStorage.getItem("token"),
          CityID:this.editForm.City,

        });
        if (crs.orsuccess == "1") {
          this.DistrictList = crs.data
        }
    },
  async getListCity(){
    const crs = await getListCity({
          token: localStorage.getItem("token"),
          ProvinceID:this.editForm.Province,

        });
        if (crs.orsuccess == "1") {
          this.cityList = crs.data
        }
    },
   delimglb(imgtype){
     if(imgtype==1){
       this.img1="";
     }else if(imgtype==2){
       this.img2="";
     }else if(imgtype==3){
       this.img3="";
     }
    },
    uploadPicture(name) {
      this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    //图片上传成功后
    handleUploadSuccess(data) {
      this.cropperModel = false
      if(this.cropperName == 'HeadUrllogo'){
         this.editForm.HeadUrl = data.url
      }
      if(this.cropperName == 'KFQrCode'){
         this.editForm.KFQrCode = data.url
      }
      if(this.cropperName == 'HeadUrl'){
         this.editForm.HeadUrllogo = data.url 
      }
      if(this.cropperName == 'img1'){
         this.img1 = data.url
      }
      if(this.cropperName == 'img2'){
         this.img2 = data.url
      }
      if(this.cropperName == 'img3'){
         this.img3 = data.url
      }
         this.cropperModel = false;
    },

    add() {
      this.timer = new Date().getTime()
      this.img1='',
      this.img2='',
      this.img3='',
      this.title = '添加门店'
      this.activeName = 'first'
        this.editForm= {
          HeadUrl:'',
          KFQrCode:'',
          StoresName:'',
          Name:'',
          Phone:'',
          StoresPhone:'', 
          StoresInfo:'',
          KstartTime:'',
          KendTime:'',
          DWAddress:'',
          longitude:'',
          latitude:'',
          Province:'',
          City:'',
          Area:'',
          Address:'',
          HeadUrllogo:'',

    }
    this.map = ''
      localStorage.setItem('contect',this.editForm.StoresInfo)
      this.editForm.KstartTime = localStorage.getItem("KstartTime"),
      this.editForm.KendTime = localStorage.getItem("KendTime"),
      this.editFormVisible = true;
  
    },

  handleEdit(row) {
      this.activeName = 'first'
      this.timer = new Date().getTime()
      this.title = '编辑门店'
      this.activeName = 'first'
       var data = { 
          SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ID:row.ID
      }
      //  let geoc = new BMap.Geocoder();
      // var that = this
      // var e = {
      //   lng: this.editForm.longitude,
      //   lat:this.editForm.latitude
      // }
      // geoc.getLocation(e.point, res=>{
      //     console.log(res);
      // })
      var that = this
       this.ajax('getStoresDetails.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.editForm = res.data
              that.map = that.editForm.DWAddress
              localStorage.setItem('contect',that.editForm.StoresInfo)
              that.editFormVisible = true;
              that.getListDistrict()
              that.getListCity()
              if(res.listStoresImg.length>0 && res.listStoresImg[0].ImgUrl !='' ){
                that.img1 = res.listStoresImg[0].ImgUrl
              } else {
                 that.img1 =""
              }
            
                          if(res.listStoresImg.length>1 && res.listStoresImg[1].ImgUrl !=''){
            that.img2 = res.listStoresImg[1].ImgUrl
              }else {
                 that.img2 =""
              }
                            if(res.listStoresImg.length>2 && res.listStoresImg[2].ImgUrl !=''){
            that.img3 = res.listStoresImg[2].ImgUrl
              }else {
                 that.img3 =""
              }
            
    
            }

        })

    },
    getList(){
       var data = { 
         SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.tableData =res.data
               
            }

        })

    },
   
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getList();
    },
    // 搜索事件
    search() {
      if (this.date) {
      } else {
        this.date = [];
      }
      console.log(this.date);
      this.getList();
      // this.getdata(this.formInline)
    },

    //显示编辑界面

    submitForm(editData){
      // console.log(this.img1)
      this.editForm.lbimgs = ''
      if(this.img1 !='' && this.img1 )
        this.editForm.lbimgs = this.editForm.lbimgs + this.img1 + ','
      if(this.img2 !='' && this.img2)
        this.editForm.lbimgs = this.editForm.lbimgs   +this.img2  + ','
      if(this.img3 !='' && this.img3)
        this.editForm.lbimgs = this.editForm.lbimgs  + this.img3
        this.editForm.SelectStoresID = this.$route.params.id,
       this.$refs[editData].validate(valid => {
        if (valid) {
            var data = this.editForm
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
              var that = this
              if(this.title == '添加门店'){
                console.log('1111')
             
                  this.ajax('addStores.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "新建成功",duration:2000,
                                  });
                                  // localStorage.setItem("HeadUrllogo", that.editForm.HeadUrllogo);
                                  //  location.reload()
                                  that.editFormVisible = false
                                  that.getList()
                                }

                            })

                  }
                  else if(this.title == '编辑门店'){
    
                  this.ajax('editStores.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  if(that.$route.params.id == localStorage.getItem("SelectStoresID")){
                                    localStorage.setItem("HeadUrllogo", that.editForm.HeadUrllogo);
                                    console.log('111',that.editForm.HeadUrllogo)
                                    location.reload()
                                  }
                         
                                  that.editFormVisible = false
                                  that.getList()
                                }                                 

                    })         
                  
              }
              } 
        
       })
       
    },
    

    // 删除公司
//     handlejin(row){
//  this.$confirm("确定要禁用吗?", "提示", {
//         confirmButtonText: "确定",
//         cancelButtonText: "取消",
//         type: "warning",
//       })
//         .then(() => {
//          var data = { SelectStoresID:this.SelectStoresID,
//           StoresID:localStorage.getItem("StoresID"),
//           token: localStorage.getItem("token"),
//           ID:row.ID,
//           Isdisable:1
//         }
//         var that = this
//         this.ajax('editStoresisable.aspx',JSON.stringify(data),"POST",function(res){

//            if (res.orsuccess == "1") {
//               that.$message({
//                 type: "success",
//                 message: "禁用成功",
//               });
//               that.getList()
//               //  that.provinceList = res.data
//             }

//         })
//         })
//         .catch(() => {
//           this.$message({
//             type: "info",
//             message: "已取消禁用",
//           });
//         });
   
// },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },closeDialog1() {
      this.showRightDrawer = false;
    },setContinue(){
      this.getListBuy();
    },getListBuy(){
        var data = { 
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
      
        var that = this
      this.ajax('getListBuy.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.BuyList = res.data
               that.showRightDrawer = true 
               that.showPopover = true;
                that.Qrcode="";
               if(res.data.length>0){
                   that.getChoosed(res.data[0],0);
                }
 
          } 

      })
    },
            // 点击选中续期时间
            getChoosed (item,idx) {
                this.index=idx;
                 this.PayForm.BuyAmount = item.BuyAmount;
                this.PayForm.BuyID = item.ID;
            },
            changePopShow(){
                this.showPopover = false;
            },
            submitToPay(){
                this.YYXBPayqrcode();
                this.showPopover = true;
            },
            // 获取二维码
            YYXBPayqrcode(){
        var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          BuyID: this.PayForm.BuyID,
           LoginID: localStorage.getItem("LoginID") 
      }
     
      
        var that = this
      this.ajax('YYXBPayqrcode.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.Qrcode = res.QRurl;
                that.NotifyId = res.NotifyId;
                that.setQRCode(that.Qrcode);
                that.setTimer(2000,that.NotifyId);
          } 

      })
    }, setQRCode(str){
                QRCode.toDataURL(str, { width:150, margin:1 }).then(res=>{
                    this.QrcodeImg = res;
                })
            },
            setTimer(time,item) {
                // debugger
                this.timer1 = setInterval (() => {
                    this.getPayNotify(item)
                },time);
                this.$once('hook:beforeDestroy', () => {
                    clearInterval(this.timer1);
                })

            },getPayNotify(item){

                  var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          NotifyId: item 
      }
     
      
        var that = this
      this.ajax('getNotify.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.showRightDrawer = false;
                that.showPopover = false;
                that.Qrcode = "";
              that.getList();
               clearInterval(that.timer1);
                        that.timer1 = null
          } 

      })
            }, closePayDrawer(){
                this.showRightDrawer = false;
                this.showPopover = false;
                this.Qrcode = "";
                clearInterval(this.timer1);
                this.timer1 = null
            }
  },
};
</script>


<style scoped>
.demo-drawer__content{
  padding-bottom: 100px;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
 .BuyBoxWrap{
        display: flex;
        justify-content: flex-start;
    }
    .BuyBoxWrap .BuyBox{
        margin-top:10px;
        margin-right:20px;
        text-align: center;
        padding:15px 0;
        border:1px solid #ccc;
        width:150px;
        line-height: 1.8;
        cursor: pointer;
    }
    .BuyBoxWrap .BuyBox:hover, .BuyBoxWrap .BuyBox.hover{
        background:#409EFF;
        color:#fff;
        border:1px solid #409EFF;
    }
    .icon-wxPay{
        color: #41af35;
        font-size: 35px;
        display: inline-block;
        vertical-align: middle;
    }
</style>

 


// WEBPACK FOOTER //
// src/views/Thailand/Thailand.vue